<template>
  <div class="order-history">
    <div class="order-history__actions">
      <oie-base-input v-model="searchPhrase" :placeholder="t('filterMyMachinesOrderHistory')" class="order-history__search">
        <template #iconPrepend>
          <oie-base-icon icon="filter-icon" size="s"></oie-base-icon>
        </template>
      </oie-base-input>

      <div class="order-history__dates">
        <datepicker
          ref="fromDate"
          v-model="fromDate"
          :placeholder="t('fromDateLabel')"
          :monday-first="true"
          wrapper-class="datepicker"
          calendar-class="datepicker-calendar"
          input-class="datepicker-input"
          format="yyyy-MM-dd"
          :language="language"
          :full-month-name="true"></datepicker>
        <datepicker
          ref="toDate"
          v-model="toDate"
          :placeholder="t('toDateLabel')"
          :monday-first="true"
          wrapper-class="datepicker"
          calendar-class="datepicker-calendar"
          input-class="datepicker-input"
          format="yyyy-MM-dd"
          :language="language"
          :full-month-name="true"></datepicker>
      </div>
    </div>
    <div>
      <h3 v-epi-edit="'OrderListHeader'" class="my-order-history__column-header">
      </h3>
      <fieldset class="my-order-history__heading-and-filter-actions">
        <legend class="sr-only">
          {{ t('orderListFilter') }}
        </legend>
        <oie-base-radio-checkbox
          v-model="showArticlesFilter"
          :label="t('showAllInvoicesFilterLabel')"
          value=""
          name="showArticlesFilter"></oie-base-radio-checkbox>

        <oie-base-radio-checkbox
          v-model="showArticlesFilter"
          :label="t('showNotSentOrderedArticlesLabel')"
          value="true"
          name="showArticlesFilter"></oie-base-radio-checkbox>

        <oie-base-radio-checkbox
          v-model="showArticlesFilter"
          value="false"
          :label="t('showSentOrderedArticlesLabel')"
          name="showArticlesFilter"></oie-base-radio-checkbox>
      </fieldset>
    </div>

    <div class="my-order-history__title">
      <h2 v-epi-edit="'OrderListHeader'">
        {{ t('orderedArticlesListHeading') }}
      </h2>
    </div>

    <div v-element-loader="{ endpoint: 'my-machines/orders' }" class="order-history__list">
      <ul v-if="orders">
        <li v-for="order in orders" :key="order.orderNumber">
          <oie-ordered-articles-item :order="order"></oie-ordered-articles-item>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { en } from 'vuejs-datepicker/dist/locale'
import httpService from '../core/http-service'
import Datepicker from 'vuejs-datepicker/dist/vuejs-datepicker.esm.js'
import _ from 'lodash'

export default {
  components: {
    Datepicker
  },
  props: {
    filterByNotSent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      orders: null,
      fromDate: null,
      toDate: null,
      searchPhrase: '',
      language: en,
      showArticlesFilter: '',
      lastCallId: 0
    }
  },
  computed: {
    queryParams() {
      return `${this.fromDate}|${this.fromDate}|${this.searchPhrase}|${this.showArticlesFilter}}`
    }
  },
  watch: {
    queryParams: _.debounce(function() {
      this.getOrderHistory()
    }, 400),
    filterByNotSent: function(newVal) {
      if (newVal) {
        this.showArticlesFilter = 'true'
      }
    }
  },
  async mounted() {
    this.toDate = new Date()
    this.fromDate = new Date()
    this.fromDate.setFullYear(this.fromDate.getFullYear() - 1)

    this.getOrderHistory()
  },
  methods: {
    async getOrderHistory() {
      const callId = ++this.lastCallId
      const response = await httpService.get('my-machines/orders', { ...this.id, fromDate: this.fromDate, toDate: this.toDate, searchPhrase: this.searchPhrase, showArticlesFilter: this.showArticlesFilter })

      if (callId === this.lastCallId) {
        this.orders = response.data
      }
    }
  }
}
</script>

<style lang="scss">
.order-history__actions {
  display: flex;
  gap: measure(eighth);
  flex-wrap: wrap;
  margin-bottom: measure(half);
}

.order-history__search {
  margin-right: auto;

  @include media(medium) {
    max-width: 20rem;
  }
}

.order-history__dates {
  display: flex;
  flex-direction: column;
  gap: measure(eighth);
  width: 100%;

  @include media(medium) {
    flex-direction: row;
    width: auto;
  }
}

.order-history__list > ul{
  @include reset-list;
}

.order-history__list > ul > li:not(:last-child){
  margin-bottom: measure(half);
}

.my-order-history__title >:first-child {
  @include h3-semi-bold;
  margin-bottom: measure(quarter);
}

.my-order-history__heading-and-filter-actions {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  margin-bottom: measure(full);

  @include media(small) {
    flex-direction: row;
    align-items: center;
  }
}

.my-order-history__heading-and-filter-actions > * {
  @include media(to-small) {
      margin-bottom: measure(half);
  }

  @include media(large) {
    margin-right: measure(half);
  }

}
.show-invoices-filter-radio {
  justify-self: end;
}

  .my-order-history__heading-and-filter-actions .radio__element:checked + .radio__label:before {
    background-color: color(brand-blue-3) !important;
    border-color: color(green-2);
  }
  .radio__element:checked + .radio__label:before {
    background-color: color(brand-blue-3)  !important;
    border-color: color(green-2);
  }
</style>
